module.exports = __webpack_public_path__ + "img/logo.9a6c6ca8.png";